
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import ProductModal from './ProductModal';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import Food from './food';
import Pollo from './pollo';
import HouseDrinks from './housedrinks';
import Liquours from './liquours';
import Digestivos from './digestivos';
import { getImageUrl } from '../../helpers/imageUrls';


function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);

     const [showCategories, setshowCategories] = useState(false);
    const [titleCategorie, setIitleCategorie] = useState('');

    const [menusData, setMenusData] = useState([]);
     const [menus, setMenus] = useState(menusCurrent);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [merch, setmerch] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showFood, setShowFood] = useState(false);
    const [showPollo, setshowPollo] = useState(false);
    const [showHouseDrinks, setshowHouseDrinks] = useState(false);
    const [showLiquors, setshowLiquors] = useState(false);
    const [showDigestivos, setshowDigestivos] = useState(false);

     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);

    
    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);

      useEffect(() => {
        menusData.map((item) => {
            
            if (item.id === 628) {
                setBeverages(item);
            }
             if (item.id === 1032) {
                setmerch(item)
            }
                
        });
      }, [menusData]);
    
const GoBeverages = () => {
          console.log({Beverages});
         setMenus(Beverages.menus)
    }


    const fetchImage = async (id) => {
        // Una sola object URL por imagen, compartida y con tope LRU (helpers/imageUrls).
        return getImageUrl(id);
    };


    const formatPrice = (value) => `$${Number(value).toFixed(2)}`;

    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        const flavors = data.flavors || [];
        useEffect(() => {
            fetchImage(`menu-image-h-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: '#6e171a', textDecoration: 'none',
                width: '100%',
                height: '100%',
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
                position: 'relative',
                borderRadius: 8,
            }}>
                <img src={image}  style={{width: '100%', height: 175, objectFit: 'cover', display: 'block', flexShrink: 0, borderRadius: '8px 8px 0 0'}}/>

                <div style={{padding: '14px 16px', flex: 1, display: 'flex', flexDirection: 'column'}}>
                    <h3 style={
                        {  color: '#fff', textTransform: 'uppercase', fontSize: 17, lineHeight: 1.15, fontWeight: '700', margin: 0, textAlign: 'left', fontFamily: 'Montserrat', whiteSpace: 'pre-line' }
                        }>

                        {/* {data.name} */}
                        {`${langEng ? data.name : translate(i18n.language, data.language, data.name)}`.replace(/\\n/g, '\n')}

                    </h3>

                    {/* {flavors.length > 0 ?
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            alignSelf: 'flex-start',
                            marginTop: 'auto',
                            gap: 14,
                            border: '1px solid #fff',
                            padding: '6px 10px',
                            color: '#fff',
                            fontFamily: 'Montserrat',
                            fontSize: 10,
                            fontWeight: '600',
                            letterSpacing: 1,
                            textTransform: 'uppercase',
                        }}>
                            <span>{langEng ? 'See Options' : 'Ver Opciones'}</span>
                            <span style={{fontSize: 13, lineHeight: 1}}>&#8250;</span>
                        </div>
                        :
                        <span style={{
                            alignSelf: 'flex-start',
                            marginTop: 'auto',
                            color: '#fff',
                            fontFamily: "'RegularSans', Helvetica, Arial, sans-serif",
                            fontSize: 18,
                            fontWeight: '400',
                            whiteSpace: 'nowrap',
                        }}>
                            {data.price > 0 ? formatPrice(data.price) : 'Market'}
                        </span>
                    } */}
                </div>
            </div>
        );
    }
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
              setShowDrinks(true)
            }} showCocktails={setShowCocktails} showLamp={false} showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={() => {
               setMenus(merch.menus)
        }}>
                
                {/* <div style={{
                   // backgroundImage: `url(${require('./assets/barra.png')})`,
                    background: '#c8a274',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '94%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '12px 14px',
                    gap: 12,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 30
                }}>
                    {menusData.map((item, key) => {
                             if (![767, 444, 445, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: '#871014',
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '12px 28px',
                                    borderRadius: 25,
                                    minWidth: 'fit-content'
                            }}
                                    onClick={() => { 
                                    if(item.id === 910) {
                                        setshowPollo(true)
                                    } else if (item.id === 917) {
                                        setshowLiquors(true)
                                    } else if (item.id === 918) {
                                        setshowDigestivos(true)
                                    } else if (item.id === 914) {
                                        setshowHouseDrinks(true)
                                    } else {    
                                        setMenus(item.menus)
                                    }
                                }}
                                >
                                    <p className='shor-text' style={{ color: '#c8a274', fontFamily: 'Noodle', fontSize: 27, margin: 0, textTransform: 'uppercase',  }}>

                                        
                                    {langEng ?
                                    `${item.name}`
                                :
                                `${translateMenu(
                                    i18n.language,
                                    item.language,
                                    item.name,
                                    'name'
                                )}`
                                        }
                                    </p>

                            </div>
                            }
                            
                        })}
                </div> */}

             
               
                <div >

                    <div style={{paddingInline: 20, textAlign: 'left'}}>
                      <div style={{display: 'inline-block'}}>
                        <h2 style={{
                            color: '#fff',
                            fontFamily: 'Montserrat',
                            fontSize: 28,
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            textAlign: 'left',
                            letterSpacing: 0.5,
                            margin: 0,
                        }}>
                            {titleCategorie}
                        </h2>
                        <div style={{width: '70%', height: 2, backgroundColor: '#fff',  margin: "10px 0 0"}} />
                      </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10,
                        paddingInline: 20,

                    }}>
                      
                         <div style={{
                            width: '100%',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gridAutoRows: 'max-content',
                            columnGap: '3%',
                            rowGap: 24,
                            padding: '0px 0px 100px 0px',
                            maxHeight: 640,
                            overflowY: 'scroll',
                            marginTop: 40,

                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                    </div>   
                    </div>
                   
                    
      

                
                
                </div>
                {showDetailProduct && <ProductModal
                    dishMenu={dataDish}
                    onClose={() => setShowDetailProduct(false)}
                />}

                
                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
             
                
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                {showPollo && <Pollo setShowHappy={setshowPollo} />}  
                {showHouseDrinks && <HouseDrinks setShowHappy={setshowHouseDrinks} />}  
                {showLiquors && <Liquours setShowHappy={setshowLiquors} />}  
                  {showDigestivos && <Digestivos setShowHappy={setshowDigestivos} />}  
                
            </LayoutContent>
        </div>
    );
}
export default Index;